module.exports = __webpack_public_path__ + "static/media/logo_login.39577a7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_login.svg
// module id = 2220
// module chunks = 0